import { BadgeM } from "@common/components/badge/BadgeM"
import TextM from "@common/components/text/TextM"
import { theme } from "@common/theme/theme"
import React from "react"

const isTrialPreparationRequest = (item) =>
    item?.material?.title?.toLowerCase().includes("demande pour la séance")

export const hasSentTrialSessionPreparation = (user) =>
    !!(
        user?.todo_activities?.find(isTrialPreparationRequest) ||
        user?.activities?.find(isTrialPreparationRequest)
    )

export function LeadScoreBadge(props) {
    const leadScore =
        props.user?.lead_score ??
        (props.user?.trial_confirmed_notification ? 1 : 0) +
            (props.user?.profile?.parent_evaluation_comment ? 1 : 0) +
            (props.user?.profile?.parent_call_requested !== null ? 1 : 0) +
            (hasSentTrialSessionPreparation(props.user) ? 1 : 0)

    return (
        <BadgeM
            style={{
                backgroundColor:
                    leadScore < 1
                        ? theme.colors.lighter
                        : leadScore >= 1 && leadScore < 3
                          ? theme.colors.accentLighter
                          : theme.colors.successLight,
            }}
            count={
                <TextM
                    fontWeight="Bold"
                    color={
                        leadScore < 1
                            ? theme.colors.light
                            : leadScore >= 1 && leadScore < 3
                              ? theme.colors.accentDark
                              : theme.colors.success
                    }
                    fontSize={12}
                >
                    {leadScore ?? "-"}/4
                </TextM>
            }
            size={14}
        />
    )
}
